import _ from 'lodash';
import globalStore from '$$globalStore';
import { prepareTaskToRefresh } from './helpers';
import app from '$$app';
import resourcesOverload from '../../resourcesOverload';

export function updateTasks(tasksToUpdate) {
  const tasksForCommit = [];
  const tasksCustomValuesForCommit = [];
  const taskIds = [];
  const projectIds = [];

  tasksToUpdate.forEach(update => {
    const taskId = update.taskId;
    const taskFromModel = globalStore.getters['tasksModel/getTask'](taskId);

    if (!taskFromModel) {
      return;
    }

    taskIds.push(+taskFromModel.id);
    projectIds.push(+taskFromModel.gantt_id);

    const updatedFields = prepareTaskToRefresh(update.updatedFields);
    const updatedTaskCustomValues = _.pick(updatedFields, ['status', 'priority']); // todo: 'jira_key' ?

    if (!_.isEmpty(updatedFields)) {
      tasksForCommit.push({ id: +taskId, gantt_id: +taskFromModel.gantt_id, ...updatedFields });
    }

    if (!_.isEmpty(updatedTaskCustomValues)) {
      tasksCustomValuesForCommit.push({
        ganttId: +taskFromModel.gantt_id,
        taskId: +taskId,
        taskCustomValues: updatedTaskCustomValues,
      });
    }
  });

  if (tasksForCommit.length) {
    globalStore.commit('tasksModel/updateTasks', { tasks: tasksForCommit, fromGantt: false }, { root: true });
    resourcesOverload.refreshCache();
  }

  if (tasksCustomValuesForCommit.length) {
    globalStore.commit('tasksModel/updateTasksCustomValues', { tasksCustomValues: tasksCustomValuesForCommit, fromGantt: false }, { root: true });
  }

  if (taskIds.length) {
    globalStore.dispatch('copyPaste/setCopyPasteError', { taskIds, text: 'can_not_copy_changes' }, { root: true });
  }

  return { taskIds, projectIds };
}

function onTaskUpdated(event) {
  const { data } = event;

  const { taskIds, projectIds } = updateTasks(data.updated);

  app.trigger('onAfterCollaboration', {
    event: event.event,
    tasks: [...new Set(taskIds)],
    resources: data.resources,
    projects: [...new Set(projectIds)],
  });
}

export default onTaskUpdated;
